import { render, staticRenderFns } from "./AppUpdatePopup.vue?vue&type=template&id=2ff35a3d&scoped=true&"
import script from "./AppUpdatePopup.vue?vue&type=script&lang=js&"
export * from "./AppUpdatePopup.vue?vue&type=script&lang=js&"
import style0 from "./AppUpdatePopup.vue?vue&type=style&index=0&id=2ff35a3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff35a3d",
  null
  
)

export default component.exports